<template>
  <alert :swag="''">
    <div class="container-fluid bg-blue-linear min-h-100 d-flex">
      <div
        class="row justify-content-center align-items-center flex-nowrap flex-column mx-auto w-100"
      >
        <div
          class="col-11 col-sm-10 col-md-8 px-0 col-md-10 d-flex flex-column mt-auto mb-md-4"
        >
          <p
            v-html="
              $route.query.message == 'APPROVED'
                ? 'Hemos recibido <br/> tu pago'
                : $route.query.message == 'DECLINED'
                ? 'Tu pago no fue exitoso'
                : $route.query.message == 'PENDING'
                ? 'Esperamos tu pago'
                : ''
            "
            class="text-white poppins-bold text-rem-2 opacity-1 text-spacing-1-15 mt-5"
          ></p>
        </div>
        <div class="col-12 mb-4 mb-md-5">
          <img
            v-if="$route.query.message == 'APPROVED'"
            src="@/assets/images/icons/green-check.svg"
            style="height:18vh; max-height:90px;"
            alt="Success Check"
            class="mt-4"
          />
          <img
            v-if="$route.query.message == 'DECLINED'"
            src="@/assets/images/icons/red-x.svg"
            height="90"
            alt="Red Cross"
            class="mt-4"
          />
          <img
            v-if="$route.query.message == 'PENDING'"
            src="@/assets/images/icons/white-clock.svg"
            height="130"
            alt="Waiting for you"
            class="mt-4"
          />
        </div>
        <div
          class="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-3 px-0 text-white-80"
        >
          <p v-if="$route.query.message == 'APPROVED'" class="">
            Tu perfil se activará en unos minutos. Guarda nuestro whatsapp por
            si necesitas ayuda
            <a
              :href="`https://api.whatsapp.com/send?phone=${client_service}`"
              target="_blank"
              class="text-white-80 text-decoration-underline"
            >
              +57-3024029675
            </a>
          </p>
          <p v-if="$route.query.message == 'DECLINED'" class="">
            Intenta nuevamente o contacta nuestro equipo de soporte a whatsapp
            <a
              :href="`https://api.whatsapp.com/send?phone=${client_service}`"
              target="_blank"
              class="text-white-80 text-decoration-underline"
            >
              +57-3024029675
            </a>
          </p>

          <p v-if="$route.query.message == 'PENDING'" class="">
            Tu perfil se activará una vez realices tu pago. Guarda nuestro
            whatsapp por si necesitas ayuda
            <a
              :href="`https://api.whatsapp.com/send?phone=${client_service}`"
              target="_blank"
              class="text-white-80 text-decoration-underline"
            >
              +57-3024029675
            </a>
          </p>
        </div>
        <div
          class="col-10 col-md-6 col-lg-4 col-xl-3 pt-4 mt-auto mb-4 mb-md-5 "
        >
          <router-link
            v-if="
              $route.query.message == 'APPROVED' ||
                $route.query.message == 'PENDING'
            "
            tag="button"
            class="bg-accent"
            to="/"
          >
            Aceptar
          </router-link>
          <router-link
            v-if="$route.query.message == 'DECLINED'"
            tag="button"
            class="bg-accent"
            to="/plans?steps=grid"
          >
            Volver a intentar
          </router-link>
          <!-- <button class="outlined-white">
                  Aceptar
                </button> -->
        </div>
      </div>
      <!--  <div class="row justify-content-center ">
              
            </div> -->
    </div>
  </alert>
</template>

<script>
import Alert from "@/components/UI/Partials/Alert.vue"
import settings from "@/api/settings"
export default {
  data() {
    return {
      client_service: settings.company_data.client_service,
      qrry: null,
    }
  },
  mounted() {
    /* DECLINED, PENDING, */
    console.log(this.$route.query)
    this.qrry = this.$route.query
  },
  components: {
    Alert,
  },
}
</script>

<style></style>
